const RELOAD_GUARD_KEY = 'bab:vite-preload-reload-pending';

export const recoverFromVitePreloadError = (event, targetWindow = window) => {
  if (!event || !targetWindow?.location?.reload) return false;

  event.preventDefault?.();

  try {
    const storage = targetWindow.sessionStorage;
    if (storage?.getItem(RELOAD_GUARD_KEY) === '1') {
      return false;
    }
    storage?.setItem(RELOAD_GUARD_KEY, '1');
  } catch (error) {
    // Ignore storage access failures and still attempt a one-off reload.
  }

  targetWindow.location.reload();
  return true;
};

export const registerVitePreloadRecovery = (targetWindow = window) => {
  if (!targetWindow?.addEventListener) return () => {};

  try {
    targetWindow.sessionStorage?.removeItem(RELOAD_GUARD_KEY);
  } catch (error) {
    // Ignore storage access failures.
  }

  const handlePreloadError = (event) => {
    recoverFromVitePreloadError(event, targetWindow);
  };

  targetWindow.addEventListener('vite:preloadError', handlePreloadError);
  return () => {
    targetWindow.removeEventListener('vite:preloadError', handlePreloadError);
  };
};
